/**
 * API URL resolver - handles custom domains (san-ia.fr) vs preview (*.preview.emergentagent.com)
 * On custom domains, uses same-origin to avoid CORS issues with credentials: 'include'
 */

const ENV_URL = process.env.REACT_APP_BACKEND_URL || '';

export function getApiUrl() {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (!hostname.includes('preview.emergentagent.com') && hostname !== 'localhost') {
      return window.location.origin;
    }
  }
  return ENV_URL;
}

export default getApiUrl;
